module.exports = __webpack_public_path__ + "img/newicon9.018af451.svg";